import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  inject,
} from '@angular/core';
@Directive({ selector: '[appTooltipWhenEllipsis]' })
export class TooltipWhenEllipsisDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);
  private renderer = inject(Renderer2);

  public domElement: HTMLElement;
  constructor() {
    this.domElement = this.elementRef.nativeElement;
    const elipsifyme: Record<string, string> = {
      'text-overflow': 'ellipsis',
      overflow: 'hidden',
      'white-space': 'nowrap',
    };
    Object.keys(elipsifyme).forEach((element) => {
      this.renderer.setStyle(this.domElement, `${element}`, elipsifyme[element]);
    });
  }
  public ngAfterViewInit(): void {
    this.renderer.setProperty(this.domElement, 'scrollTop', 1);
    this.setToolTip();
  }
  @HostListener('window:resize')
  public setToolTip(): void {
    if (this.domElement.offsetWidth < this.domElement.scrollWidth) {
      this.renderer.setAttribute(this.domElement, 'title', this.domElement.textContent);
    } else {
      this.renderer.removeAttribute(this.domElement, 'title');
    }
  }
}
